import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
import { Footer } from '../components/Footer';
export function TermsOfService() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-cream flex flex-col" data-id="element-237">
      <main className="flex-grow max-w-3xl mx-auto px-6 py-16 w-full" data-id="element-238">
        <Link to="/" className="inline-flex items-center text-navy hover:text-gold transition-colors mb-8 font-medium" data-id="element-239">
          <ArrowLeftIcon className="w-4 h-4 mr-2" data-id="element-240" />
          Volver al inicio
        </Link>

        <article className="prose prose-navy max-w-none" data-id="element-241">
          <h1 className="font-heading text-4xl md:text-5xl text-navy mb-4" data-id="element-242">
            Términos del Servicio
          </h1>
          <p className="text-gray-500 mb-8" data-id="element-243">
            Última actualización: 21 de marzo de 2026
          </p>

          <div className="space-y-8 text-gray-700" data-id="element-244">
            <section data-id="element-245">
              <h2 className="font-heading text-2xl text-navy mb-3" data-id="element-246">
                1. Aceptación
              </h2>
              <p data-id="element-247">
                Al utilizar este sitio web, aceptas estos Términos. Si no estás
                de acuerdo, no utilices el sitio.
              </p>
            </section>

            <section data-id="element-248">
              <h2 className="font-heading text-2xl text-navy mb-3" data-id="element-249">
                2. Contenido educativo
              </h2>
              <p data-id="element-250">
                El contenido es informativo y educativo y no constituye asesoría
                legal, fiscal o financiera. La elegibilidad, condiciones y
                costos de seguros varían según la persona, el estado y la
                suscripción de la aseguradora.
              </p>
            </section>

            <section data-id="element-251">
              <h2 className="font-heading text-2xl text-navy mb-3" data-id="element-252">
                3. Responsabilidad del usuario
              </h2>
              <p data-id="element-253">
                Te comprometes a brindar información veraz al contactarnos y
                usar el sitio de forma legal.
              </p>
            </section>

            <section data-id="element-254">
              <h2 className="font-heading text-2xl text-navy mb-3" data-id="element-255">
                4. Precio
              </h2>
              <p data-id="element-256">
                El ebook se entrega gratis. Cualquier referencia a un valor
                anterior (por ejemplo, $17) se muestra únicamente como valor de
                referencia/promocional.
              </p>
            </section>

            <section data-id="element-257">
              <h2 className="font-heading text-2xl text-navy mb-3" data-id="element-258">
                5. Reembolsos
              </h2>
              <p data-id="element-259">No aplica reembolso porque el ebook es gratuito.</p>
            </section>

            <section data-id="element-260">
              <h2 className="font-heading text-2xl text-navy mb-3" data-id="element-261">
                6. Uso del material
              </h2>
              <p data-id="element-262">
                El ebook es para uso personal. No se permite revender,
                reproducir o redistribuir sin autorización.
              </p>
            </section>

            <section data-id="element-263">
              <h2 className="font-heading text-2xl text-navy mb-3" data-id="element-264">
                7. Limitación de responsabilidad
              </h2>
              <p data-id="element-265">
                No somos responsables por decisiones tomadas basadas en este
                contenido. Para asesoría específica, consulta profesionales.
              </p>
            </section>

            <section data-id="element-266">
              <h2 className="font-heading text-2xl text-navy mb-3" data-id="element-267">
                8. Contacto
              </h2>
              <p data-id="element-268">
                Soporte: WhatsApp{' '}
                <strong className="text-navy" data-id="element-269">+1 786 397 5041</strong>
              </p>
            </section>
          </div>
        </article>
      </main>
      <Footer data-id="element-270" />
    </div>;
}